import { useTranslation } from "react-i18next";

const MerchantBusinessPlanOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "sme",
      title: t("options.merchantBusinessPlan.sme"),
      value: "sme",
    },
    {
      key: "normal",
      title: t("options.merchantBusinessPlan.normal"),
      value: "normal",
    },
  ];

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default MerchantBusinessPlanOptions;
